import React from 'react';
const comparisonRows = [{
  situation: 'Tu cursada',
  without: 'Materias sueltas sin conexión',
  with: 'Todo ordenado por área y materia'
}, {
  situation: 'Parciales',
  without: 'Estudiás de cero cada vez',
  with: 'Resúmenes y protocolos listos'
}, {
  situation: 'Finales',
  without: 'Sin saber por dónde empezar',
  with: 'Banco de preguntas por materia'
}, {
  situation: 'TPs y prácticos',
  without: 'Horas buscando info dispersa',
  with: 'Fichas de evaluación para adaptar'
}, {
  situation: 'Práctica hospitalaria',
  without: 'Llegás sin saber qué hacer',
  with: 'Protocolo completo de rotación'
}, {
  situation: 'Cuando te recibís',
  without: 'Sin saber cómo arrancar',
  with: 'Sistema listo para tu consultorio'
}, {
  situation: 'Cobro profesional',
  without: 'Sin política clara',
  with: 'Contrato + arancel listos'
}, {
  situation: 'Tu identidad profesional',
  without: 'Sin estrategia ni contenido',
  with: '30 días de contenido listo'
}];
const blocks = [{
  num: '01',
  emoji: '💼',
  title: 'Tu Primer Consultorio Kinésico',
  desc: 'Todo lo que necesitás para arrancar: contrato, consentimiento informado y política de cobro.'
}, {
  num: '02',
  emoji: '💰',
  title: 'Cobro Profesional Blindado',
  desc: 'Sistema de abono mensual adelantado + planilla de pagos + calculadora de honorarios kinésicos.'
}, {
  num: '03',
  emoji: '📋',
  title: 'Historia Clínica en 5 Minutos',
  desc: 'Frases clínicas copy/paste. Registro de evolución kinésica listo para usar desde el día uno.'
}, {
  num: '04',
  emoji: '📱',
  title: 'Presencia Digital Lista',
  desc: '20 tipos de post + calendario de 30 días + 20 stories listos para publicar como kinesiólogo.'
}];
const assets = ['Planilla de Pagos', 'Calculadora de Honorarios', 'Reglamento Interno', 'Contrato de Servicios', 'Consentimiento Informado', 'Autorización de Imagen', '20 Stories Listos'];
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(239,246,255) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-222">
      <div className="mx-auto max-w-4xl" data-id="element-223">
        {/* Header */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-224">
          ¿Qué agrega{' '}
          <span className="text-blue-700" data-id="element-225">Máster Kinesiología™?</span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-8" data-id="element-226">
          El sistema completo para que cuando te recibas, no arranques de cero.
          Tu consultorio, tu cobro y tu identidad profesional, listos.
        </p>

        {/* Scroll hint mobile */}
        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-227">
          <span data-id="element-228">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(59,130,246,0.2)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-229">
          <div className="min-w-[560px] bg-white rounded-xl overflow-hidden" data-id="element-230">
            {/* Table Header */}
            <div className="grid grid-cols-3 border-b border-gray-100" data-id="element-231">
              <div className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-232">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold text-gray-400 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-233">
                ❌ Sin Máster Kinesiología
              </div>
              <div className="px-4 py-3 text-xs font-bold text-blue-700 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-234">
                ✅ Con Máster Kinesiología
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-235">
                <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-236">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-gray-500 border-l border-gray-100 bg-gray-50 text-center" data-id="element-237">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-gray-900 border-l border-gray-100 text-center" style={{
              backgroundColor: 'rgb(239,246,255)'
            }} data-id="element-238">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Blocks */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-239">
          <div className="bg-blue-700 px-5 py-3" data-id="element-240">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-241">
              🏆 MÁSTER KINESIOLOGÍA™ INCLUYE:
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-242">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" data-id="element-243">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-244">
                  {block.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-245">
                  <span className="block text-sm font-black text-gray-900" data-id="element-246">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-247">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Assets */}
        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgb(239,246,255)',
        border: '1px solid rgba(59,130,246,0.2)'
      }} data-id="element-248">
          <p className="text-xs font-bold text-blue-700 uppercase tracking-widest m-0 mb-3" data-id="element-249">
            📊 Assets incluidos:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-250">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold text-blue-700 bg-white border border-blue-700/20 rounded-full px-3 py-1" data-id="element-251">
                {asset}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}